import { create } from "zustand";
import { updateUserSettings } from "../../api";
import type { PersonalizationStore } from "../types";

export const usePersonalizationStore = create<PersonalizationStore>((set) => ({
    answerLength: (() => {
        const saved = localStorage.getItem('answerLength');
        return (saved as 'brief' | 'standard' | 'detailed') || 'standard';
    })(),
    enableIcons: (() => {
        const saved = localStorage.getItem('enableIcons');
        return saved ? saved === 'true' : false;
    })(),
    responseTone: (() => {
        const saved = localStorage.getItem('responseTone');
        return (saved as 'professional' | 'standard' | 'friendly') || 'standard';
    })(),
    setAnswerLength: (response_length: 'brief' | 'standard' | 'detailed') => {
        localStorage.setItem('answerLength', response_length);
        set({ answerLength: response_length });
        void updateUserSettings({ response_length });
    },
    setEnableIcons: (emojis_enabled: boolean) => {
        localStorage.setItem('enableIcons', emojis_enabled.toString());
        set({ enableIcons: emojis_enabled });
        void updateUserSettings({ emojis_enabled });
    },
    setResponseTone: (response_tone: 'professional' | 'standard' | 'friendly') => {
        localStorage.setItem('responseTone', response_tone);
        set({ responseTone: response_tone });
        void updateUserSettings({ response_tone });
    },
}));
